import { render } from "./TableIncidence_subcategories.vue?vue&type=template&id=7fce0230&scoped=true"
import script from "./TableIncidence_subcategories.vue?vue&type=script&lang=js"
export * from "./TableIncidence_subcategories.vue?vue&type=script&lang=js"

import "./TableIncidence_subcategories.vue?vue&type=style&index=0&id=7fce0230&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fce0230"]])

export default __exports__